import { Column } from "@ant-design/charts";
import type { CardProps } from "antd";
import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { DashboardCardContainer } from "src/app/features/Dashboard/utils/dashboardStyles";
import { SecondaryButton } from "../../../../components/Buttons/components/ActionButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import type { TerminalStatusDataDto } from "../types/Dashboard";

interface TerminalStatusCardProps extends CardProps {
    data: TerminalStatusDataDto[];
}

/**
 * TerminalStatusCard - Stacked column chart showing terminal status (Updated/In Progress/Failed) over a week
 */
export const TerminalStatusCard: FC<TerminalStatusCardProps> = ({ data, ...cardProps }) => {
    const navigate = useNavigate();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const config: any = {
        data,
        xField: "day",
        yField: "value",
        colorField: "status",
        stack: true,
        label: {
            position: "top" as const,
            offset: 10,
            style: {
                fill: "transparent",
            },
        },
        interactions: [
            {
                type: "active-region",
                enable: false,
            },
        ],
        columnBackground: {
            style: {
                fill: "rgba(0,0,0,0.1)",
            },
        },
        legend: {
            position: "bottom" as const,
        },
    };

    const handleSeeAll = () => {
        navigate(`${BASE_PATH}/${ResourceName.TERMINAL_VERSIONS}`);
    };

    return (
        <DashboardCardContainer
            title={i18n.t("dashboard.terminalStatus")}
            extra={<SecondaryButton onClick={handleSeeAll}>{i18n.t("dashboard.seeAll")}</SecondaryButton>}
            {...cardProps}
        >
            <Column {...config} />
        </DashboardCardContainer>
    );
};
